module.exports = __webpack_public_path__ + "static/media/2 (10).e530a4f8.jpg";